var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"severity-badge",class:'severity-badge--' + _vm.severity},[_vm._v(_vm._s(_vm._label))])
}
var staticRenderFns = []

export { render, staticRenderFns }